export abstract class Constants {
    static readonly SHIP_TO_ACCOUNT_NUMBER = 'shipToAccountNumber';
    static readonly BILL_TO_ACCOUNT_NUMBER = 'billToAccountNumber';
}
